export class UserNotification {
  public key: string; // used to uniquely identify notification to determine to add or update
  public updatedDate: Date; // used for sorting and to know when notification last updated
  public message: string; // used to display a message to the user for what the notification is about
  public isRead: boolean; // used to indicate if the user has read the notification
  public isErrorMessage: boolean; // used to indidcate if the message is for an error
  public url?: string; // (optional) to be used for providing a user with a link to a location related to the notification
  public notificationType: number; // used to indicate notification Type in notification
  public isRequestCompleted: boolean; // used to indicate Request Completed in notification
  public createdDate: Date; // used to know when notification created
  public duration: number;
}
